// node modules
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// components
import Link from 'components/Link';

// assets
import s from './Button.scss';

class Button extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    size: PropTypes.string,
    themeName: PropTypes.string,
    themeType: PropTypes.oneOf(['', 'clear', 'outline']),
  };

  static defaultProps = {
    className: '',
    disabled: false,
    href: null,
    size: 'default',
    themeName: '',
    themeType: '',
  };

  render() {
    const { className, themeName, themeType, size, disabled, href, ...more } = this.props;
    const buttonClassName = classNames(className, 'button', {
      [s[`button--${themeName}`]]: themeName !== '',
      [s[`button--${themeType}`]]: themeType !== '',
      [s[`button--size-${size}`]]: size,
      'button--disabled': disabled,
    });
    if (href) {
      if (/^https?:/.test(href)) {
        return (
          <a href={href} className={buttonClassName} {...more}>
            {this.props.children}
          </a>
        );
      }
      return (
        <Link to={href} className={buttonClassName} {...more}>
          {this.props.children}
        </Link>
      );
    }
    return (
      <button className={buttonClassName} disabled={disabled} {...more}>
        {this.props.children}
      </button>
    );
  }
}

export default withStyles(s)(Button);
